import React, { memo } from 'react';

interface WizardPanelProps {
  isVisible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Sliding panel wrapper for the suggestion wizard.
 * Includes backdrop overlay and animation handling.
 */
export const WizardPanel = memo<WizardPanelProps>(({ isVisible, onClose, children }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/5 z-[100] transition-opacity duration-300 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onClose}
      />

      {/* Sliding Right Panel - full screen on mobile, fixed width panel on sm+ */}
      <div
        data-tour="suggestion-wizard"
        className={`fixed inset-0 sm:inset-auto sm:top-0 sm:right-0 sm:bottom-0 w-full sm:w-[400px] bg-white sm:border-l border-gray-200 shadow-2xl z-[110] flex flex-col overflow-hidden transition-transform duration-300 ease-out ${
          isVisible ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {children}
      </div>
    </>
  );
});

WizardPanel.displayName = 'WizardPanel';

export default WizardPanel;
